import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_ALL_CHIEF_REQUEST = "GET_ALL_CHIEF_REQUEST";
export const GET_ALL_CHIEF_SUCCESS = "GET_ALL_CHIEF_SUCCESS";
export const GET_ALL_CHIEF_ERROR = "GET_ALL_CHIEF_ERROR";

//* ACTIONS ------------------------------------------------
export const getAllChiefRequest = (payload = {}, callback) => ({
  type: GET_ALL_CHIEF_REQUEST,
  payload,
  callback,
});

export const getAllChiefSuccess = (data) => ({
  type: GET_ALL_CHIEF_SUCCESS,
  payload: data,
});

export const getAllChiefError = (error) => ({
  type: GET_ALL_CHIEF_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getAllChiefServiceRequest = async (params = {}) => {
  const options = await withToken({
    method: Methods.GET,
    params,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(`/employees/chiefs`, options);
};
